export default "__VITE_ASSET__C$xBFz9F__"